import { IPage } from 'src/Entities/Pages';
import {
  IAddPageAction,
  IUpdatePageAction,
  IDeletePageAction,
  IReorderPagesAction,
  IUpsertPageAction
} from './types';

export interface IPagesState {
  entities: {
    [key: string]: IPage;
  }
  list: {
    status: 'idle' | 'fetching';
    ids: number[];
  }
}

export type Action =
  | { type: 'FETCH_LIST_REQUEST' }
  | { type: 'FETCH_LIST_SUCCESS', pages: IPage[] }
  | IAddPageAction
  | IUpdatePageAction
  | IDeletePageAction
  | IReorderPagesAction
  | IUpsertPageAction;

const pagesToEntityMap = (pages: IPage[]): IPagesState['entities'] => {
  const map = {};

  pages.forEach((page) => {
    map[page.portalPageId] = page;
  });

  return map;
};

export const initialState: IPagesState = {
  entities: {},
  list: {
    status: 'idle',
    ids: [],
  },
};

const addPage = (state: IPagesState, action: IAddPageAction): IPagesState => {
  const { entities, list } = state;
  const { page } = action;

  return {
    entities: { ...entities, [page.portalPageId]: page },
    list: {
      ...list,
      ids: list.ids.filter((id) => id !== page.portalPageId).concat(page.portalPageId),
    },
  };
};

const updatePage = (state: IPagesState, action: IUpdatePageAction): IPagesState => {
  const { entities } = state;
  const { page } = action;

  return {
    ...state,
    entities: { ...entities, [page.portalPageId]: page }
  };
};

const upsertPage = (state: IPagesState, action: IUpsertPageAction): IPagesState => {
  const { page } = action;
  const { entities, list } = state;
  const { ids } = list;

  const entity = Object.assign({}, entities[page.portalPageId], page);

  return {
    ...state,
    entities: { ...entities, [page.portalPageId]: entity },
    list: {
      ...list,
      ids: ids.filter((id) => id !== page.portalPageId).concat(page.portalPageId)
    }
  };
}

const deletePage = (state: IPagesState, action: IDeletePageAction): IPagesState => {
  const { list } = state;
  const entities = { ...state.entities };

  delete entities[action.id];

  return {
    ...state,
    entities,
    list: {
      ...list,
      ids: list.ids.filter((id) => id !== action.id)
    }
  };
};

const reorderPages = (state: IPagesState, action: IReorderPagesAction): IPagesState => {
  return state;
};

export default (state: IPagesState = initialState, action: Action): IPagesState => {
  switch (action.type) {
    case 'FETCH_LIST_SUCCESS':
      return {
        ...state,
        entities: pagesToEntityMap(action.pages),
        list: {
          status: 'idle',
          ids: action.pages.map((page) => page.portalPageId),
        }
      }
    case 'ADD_PAGE': return addPage(state, action);
    case 'UPDATE_PAGE': return updatePage(state, action);
    case 'UPSERT_PAGE': return upsertPage(state, action);
    case 'DELETE_PAGE': return deletePage(state, action);
    case 'REORDER_PAGES': return reorderPages(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/context/pages/reducer.ts